import API_BASE_URL from '../config/api';

export const getAddressSuggestions = async (query, signal) => {
  const q = (query || '').trim();
  if (q.length < 3) return [];
  const response = await fetch(`${API_BASE_URL}/geocoding/suggest?q=${encodeURIComponent(q)}`, { signal });
  if (!response.ok) throw new Error('Erreur lors de la recherche d\'adresse');
  return response.json();
};
